export default __webpack_public_path__ + "static/kubernetes-highlevel-architecture-e67b1567993f4dff8ff0987ac89ac90d.webp";